import React from 'react';
import { useTranslation } from 'react-i18next';
import useClasses from '../../hooks/useClasses';
import ExerciseTeaser from '../ExerciseTeaser';

import './style.scss';

type Exercise = {
  exerciseId: string
  icon: string
  title: string
  isComplete: boolean
};

interface Props {
  phaseNumber: number
  exercises: {
    [key: string]: Exercise
  }
  onClick?: (exercise: Exercise) => void
}

const PhaseTeaser: React.FC<Props> = ({
  phaseNumber,
  exercises,
  onClick,
}) => {
  const { t } = useTranslation();
  const exerciseIds = Object.keys(exercises);
  const phaseStarted = exerciseIds.some((id) => exercises[id].isComplete);

  const { buildClass } = useClasses('PhaseTeaser', {
    'is-started': phaseStarted,
  });

  function getPosition(index: number) {
    const maximum = Math.max(0, exerciseIds.length - 1);
    if (index === 0 && index === maximum) {
      return 'only';
    }

    if (index === 0) {
      return 'first';
    }

    if (index === maximum) {
      return 'last';
    }

    return null;
  }

  return (
    <div className={buildClass()}>
      <div className={buildClass('content')}>
        <div className={buildClass('header')}>
          <h2 className={buildClass('title')}>{t('paragraphs.phase.start', { phase: phaseNumber })}</h2>
          <div className={buildClass('progress-line')} />
        </div>
        {exerciseIds.map((exerciseId, index) => (
          <ExerciseTeaser
            exerciseId={exerciseId}
            key={exerciseId}
            icon={exercises[exerciseId].icon}
            title={exercises[exerciseId].title}
            isComplete={exercises[exerciseId].isComplete}
            position={getPosition(index)}
            {...(onClick ? {
              onClick: () => {
                onClick(exercises[exerciseId]);
              },
            } : {})}
          />
        ))}
      </div>
    </div>
  );
};

export default PhaseTeaser;
